import man1 from "../../assets/menEmoji/man1.png";
import man2 from "../../assets/menEmoji/man2.png";
import man3 from "../../assets/menEmoji/man3.png";
import man4 from "../../assets/menEmoji/man4.png";
import man5 from "../../assets/menEmoji/man5.png";
import man6 from "../../assets/menEmoji/man6.png";
import man7 from "../../assets/menEmoji/man7.png";
import man8 from "../../assets/menEmoji/man8.png";
import woman1 from "../../assets/womenEmoji/woman1.png";
import woman2 from "../../assets/womenEmoji/woman2.png";
import woman3 from "../../assets/womenEmoji/woman3.png";
import woman4 from "../../assets/womenEmoji/woman4.png";
import woman5 from "../../assets/womenEmoji/woman5.png";
import woman6 from "../../assets/womenEmoji/woman6.png";
import woman7 from "../../assets/womenEmoji/woman7.png";
import woman8 from "../../assets/womenEmoji/woman8.png";
import woman9 from "../../assets/womenEmoji/woman9.png";
import woman10 from "../../assets/womenEmoji/woman10.png";
import woman11 from "../../assets/womenEmoji/woman11.png";
import woman12 from "../../assets/womenEmoji/woman12.png";

const MEN = [man1, man2, man3, man4, man5, man6, man7, man8];
const WOMEN = [woman1, woman2, woman3, woman4, woman5, woman6, woman7, woman8, woman9, woman10, woman11, woman12];

const pool = (gender) => (gender === "female" ? WOMEN : MEN);

export const randomAvatar = (gender) => {
  const images = pool(gender);
  return images[Math.floor(Math.random() * images.length)];
};

// Stable avatar for a list position, so rows don't change on re-render.
export const avatarAt = (gender, index) => {
  const images = pool(gender);
  return images[index % images.length];
};
